import { Component, OnInit } from '@angular/core';
import {EventListAction} from '../event/ApiAction/EventListAction';
import {EventModel} from '../../data/model/EventModel/Event.model';
import {AppConstants} from '../../shared/constants/app-constants';
import {DataManagerService} from '../../data/services/DataManager/data-manager.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DetailRow} from '../../ui/detail-card/payarc-detail-card.component';
import {DateFormatPipe} from '../../shared/custom-pipes/date-format-pipe/dateformatpipe';
import {Camalize} from '../../shared/custom-pipes/camalize/camalize';

const dateFormatPipe = new DateFormatPipe();
const camalizePipe = new Camalize();

@Component({
    selector: 'app-event-details',
    templateUrl: './event-details.component.html',
    styleUrls: ['./event-details.component.css'],
    standalone: false
})
export class EventDetailsComponent extends EventListAction implements OnInit {

  dataManager: DataManagerService;
  eventData: EventModel;

  get eventDetailRows(): DetailRow[] {
    return [
      { label: 'ID', value: this.eventData.id || '--' },
      { label: 'Type', value: this.eventData.type || this.eventData.event_type || '--' },
      { label: 'Created', value: this.eventData.created_at ? dateFormatPipe.transform(this.eventData.created_at, 'MM/dd/yyyy hh:mm') : '--' },
      { label: 'Description', value: this.eventData.description ? camalizePipe.transform(this.eventData.description, true).replace('usd', 'USD') : '--' },
    ];
  }

  constructor(dataManager: DataManagerService, router: Router, route: ActivatedRoute) {
    super();
    this.dataManager = dataManager;
    this.errorMsg = null;
    this.router = router;
    this.route = route;
    this.eventData = new EventModel();
    if (this.fetchIdFromRouteQueryParams()) {
      this.route.queryParams.subscribe((params) => {
        this._eventListUrl = AppConstants.BASE_URL + AppConstants.SERVICE_NAME_EVENT + '/' + params['id'];
      });
      this.getEventListData();
    }

  }

  ngOnInit() {
  }
  protected passEventList(eventResponse) {
    this.loadFlag = false;
    this.eventData = new EventModel(eventResponse.data);
    console.log('eventResponse', eventResponse);
    console.log('eventData', this.eventData);
  }

  protected passError(error: any) {
    this.loadFlag = false;
  }


}
